export default "__VITE_ASSET__BrZQMeoC__"